import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=35893510&scoped=true&lang=pug"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35893510",
  null
  
)

export default component.exports